import LimitConfigurator from "./limit-configurator/LimitConfiguratorModule";
import ConfiguredLimits from "./configured-limits/ConfiguredLimitsModule";
import Log from "./log/FrequencyTrendLimitLogModule";
import FrequencyLimitsFactory from "../factories/FrequencyLimitsFactory";
import FrequencyTrendLimitConfigurationActions from "./FrequencyTrendLimitConfigurationActions";
import FrequencyTrendLimitConfigurationMutations from "./FrequencyTrendLimitConfigurationMutations";

const state = FrequencyLimitsFactory.EmptyState();

const { actions } = FrequencyTrendLimitConfigurationActions;

const { mutations } = FrequencyTrendLimitConfigurationMutations;

const namespaced = true;

export default {
	state,
	actions,
	mutations,
	namespaced,
	modules: {
		LimitConfigurator,
		ConfiguredLimits,
		Log
	}
};